import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
// import { FundriskService } from 'src/app/services/fundrisk.service';
import { MainService } from 'src/app/services/main.service';
@Component({
  selector: 'app-oneam-index-level',
  templateUrl: './oneam-index-level.component.html',
  styleUrls: ['./oneam-index-level.component.scss']
})
export class OneamIndexLevelComponent implements OnInit {

  language = JSON.parse(localStorage.getItem('language'));
  language_flag = localStorage.getItem('language_flag');

  @Input()
  fundList = []
  disableHeader = false

  @Input()
  currentPage

  @Input()
  totalPage

  @Output()
  currentPageChange = new EventEmitter()

  disableIcon: boolean = false

  selectedContent: any = {}
  selectedContent2: any;
  filterList: any;
  disclaimer: string;


  res: any

  constructor(private route: ActivatedRoute, private router: Router, private MainService: MainService,
    private loader: NgxUiLoaderService) { }

  ngOnInit() {
    this.currentPage = 1;
    this.route.params.subscribe(param => {
      if (param['id'] == 'one-complexreturn') {
        this.loader.start();
        this.MainService.GetIndexLevelList().subscribe(response => {
          console.log(response);
          this.selectedContent2 = response;
          this.selectedContent2.forEach(element => {
            element.IndexDate = new Date(element.IndexDate).toLocaleDateString('en-GB')
          });
          this.totalPage = this.setTotalPage(this.selectedContent2)
          this.renderListPerPage(this.selectedContent2)
          this.loader.stop();
        })
      }
    })
  }
  setCurrentPage(event) {
    this.currentPage = event;
    this.renderListPerPage(this.selectedContent2);
  }

  renderListPerPage(indexlists) {
    if (indexlists !== undefined) {
      this.filterList = indexlists.slice(this.currentPage * 10 - 10, this.currentPage * 10)
    }
  }
  setTotalPage(objectFundType) {
    if (Object.keys(objectFundType).length <= 10) {
      return 1
    } else {
      return Math.ceil(Object.keys(objectFundType).length / 10)
    }
  }

}
